import React from 'react';
import { Entity } from '@backstage/catalog-model';
import { Chip } from '@material-ui/core';
import {
  DefaultEntityFilters,
  EntityLifecycleFilter,
} from '@backstage/plugin-catalog-react';

export const getTagIcon = (name: string) => {
  switch (name) {
    case 'bu':
      return (
        <svg
          style={{ verticalAlign: 'text-top' }}
          width={16}
          viewBox="0 0 22 22"
        >
          <path
            d="M20.396 11a3.487 3.487 0 0 0-2.008-3.062 3.474 3.474 0 0 0-.742-3.584 3.474 3.474 0 0 0-3.584-.742A3.468 3.468 0 0 0 11 1.604a3.463 3.463 0 0 0-3.053 2.008 3.472 3.472 0 0 0-1.902-.14c-.635.13-1.22.436-1.69.882a3.461 3.461 0 0 0-.734 3.584A3.49 3.49 0 0 0 1.604 11a3.496 3.496 0 0 0 2.017 3.062 3.471 3.471 0 0 0 .733 3.584 3.49 3.49 0 0 0 3.584.742A3.487 3.487 0 0 0 11 20.396a3.476 3.476 0 0 0 3.062-2.007 3.335 3.335 0 0 0 4.326-4.327A3.487 3.487 0 0 0 20.396 11zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"
            fill="#1D9BF0"
          />
        </svg>
      );
    default:
      return '';
  }
};

export const extractTagName = (
  metaOrTag: string,
): { label: JSX.Element | string; key: string } => {
  const kv = metaOrTag.split(':');
  const isMeta = kv.length === 2;
  if (isMeta) {
    return {
      label: (
        <>
          {kv[1]} {getTagIcon(kv[0])}
        </>
      ),
      key: kv[1],
    };
  }
  return {
    label: metaOrTag,
    key: metaOrTag,
  };
};

export const subheaderForEntity = (
  entity: Entity,
  updateFilters: Function,
  filters: DefaultEntityFilters,
  classes: {
    squareChip: string;
    chipContainer: string;
  },
) => {
  if (!entity || !entity.spec) return null;
  const subheading: React.ReactNode[] = [];
  if (entity.spec) {
    if (entity.spec.type)
      subheading.push(
        <Chip
          className={classes.squareChip}
          key="1"
          label={entity.spec.type.toString()}
        />,
      );
    if (entity.spec.lifecycle)
      subheading.push(
        <Chip
          className={classes.squareChip}
          key="0"
          label={entity.spec.lifecycle.toString().replaceAll('-', ' ')}
          color={
            entity.spec.lifecycle === 'coming-soon' ? 'secondary' : 'primary'
          }
          onClick={() =>
            updateFilters({
              lifecycles: new EntityLifecycleFilter([
                ...new Set(
                  filters.lifecycles?.values?.concat([
                    entity.spec?.lifecycle?.toString() ?? '',
                  ]) || [entity.spec?.lifecycle?.toString() ?? ''],
                ),
              ]),
            })
          }
        />,
      );
  }
  if (!subheading.length) return null;
  // return subheading.filter(it => it && it.length).join(' ');
  return <div className={classes.chipContainer}>{subheading}</div>;
};
